import { OrganizationCreate } from "@boark/shared/types/organization-create";
import { OrganizationUpdate } from "@boark/shared/types/organization-update";
import {
  OrganizationWithHoldingsAndLeasesAndSubletsAndApartment,
  organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
} from "@boark/shared/types/organization-with-holdings-and-leases-and-sublets-and-apartment";
import * as z from "zod";

import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
  request,
} from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export async function getOrganizations(): Promise<
  OrganizationWithHoldingsAndLeasesAndSubletsAndApartment[]
> {
  return request(`${API_BASE_URL}/organization`, {
    schema: z.array(
      organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
    ),
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export async function getOrganization(
  id: string,
): Promise<OrganizationWithHoldingsAndLeasesAndSubletsAndApartment> {
  return await getRequest(
    `${API_BASE_URL}/organization/${id}`,
    organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
  );
}

export async function createOrganization(
  organization: OrganizationCreate,
): Promise<OrganizationWithHoldingsAndLeasesAndSubletsAndApartment> {
  return await postRequest(
    `${API_BASE_URL}/organization`,
    organization,
    organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
  );
}

export async function updateOrganization(
  id: string,
  organization: OrganizationUpdate,
): Promise<OrganizationWithHoldingsAndLeasesAndSubletsAndApartment> {
  return await putRequest(
    `${API_BASE_URL}/organization/${id}`,
    organization,
    organizationWithHoldingsAndLeasesAndSubletsAndApartmentSchema,
  );
}

export async function deleteOrganization(id: string): Promise<void> {
  return await deleteRequest(`${API_BASE_URL}/organization/${id}`);
}

export function formatOrganizationLabel({
  name,
  corporateRegistrationNumber,
}: {
  name?: string;
  corporateRegistrationNumber: string;
}): string {
  return `${name || "-"} (${corporateRegistrationNumber})`;
}
